import request from '@/router/axios'

// 资质申请
export function CreateQualifications(query) {
    return request({
        url: '/api/services/app/TestOrg/CreateQualifications',
        method: 'post',
        data: query
    })
}

// 资质详情
export function GetTestQualificationsDetails(query) {
    return request({
        url: '/api/services/app/TestOrg/GetTestQualificationsDetails',
        method: 'post',
        data: query
    })
}

// 简称查重
export function UpdateNickName(query) {
    return request({
        url: '/api/services/app/TestOrg/UpdateNickName',
        method: 'post',
        data: query
    })
}

// 测试列表
export function GetTestApplyList(query) {
    return request({
        url: '/api/services/app/TestOrg/GetTestApplyList',
        method: 'post',
        data: query
    })
}

// 测试列表
export function GetExaminerClassList(query) {
    return request({
        url: '/api/services/app/TestOrg/GetExaminerClassList',
        method: 'post',
        data: query
    })
}

// 新增测试班获得测试场地
export function GetSites(query) {
    return request({
        url: '/api/services/app/TestOrg/GetSites',
        method: 'post',
        data: query
    })
}

// 新增测试班获得测试等级
export function GetGrades(query) {
    return request({
        url: '/api/services/app/TestOrg/GetGrades',
        method: 'post',
        data: query
    })
}

// 提交新增测试班
export function CreateTestApply(query) {
    return request({
        url: '/api/services/app/TestOrg/CreateTestApply',
        method: 'post',
        data: query
    })
}

// 报名信息列表
export function GetAthleteTestApplication(query) {
    return request({
        url: '/api/services/app/TestOrg/GetAthleteTestApplication',
        method: 'post',
        data: query
    })
}

//成绩列表  XXL  2021年5月26日 11:36:32
export function GetAthleteTestApplicationScore(query) {
    return request({
        url: '/api/services/app/TestOrg/GetAthleteTestApplicationScore',
        method: 'post',
        data: query
    })
}

// 下载报名信息
export function AthleteTestRegistration(query) {
    return request({
        url: '/api/services/app/TestOrg/AthleteTestRegistration',
        method: 'post',
        data: query
    })
}

// 批量报名
export function BulkRegistration(query) {
    return request({
        url: '/api/services/app/TestOrg/BulkRegistration',
        method: 'post',
        data: query
    })
}

// 测试编排
export function ImportTestSchedult(query) {
    return request({
        url: '/api/services/app/TestOrg/ImportTestSchedult',
        method: 'post',
        data: query
    })
}

// 视频录像
export function TestVideoData(query) {
    return request({
        url: '/api/services/app/TestVideo/TestVideoData',
        method: 'post',
        data: query
    })
}

//成绩录入
export function ImportTestResult(query) {
    return request({
        url: '/api/services/app/TestOrg/ImportTestResult',
        method: 'post',
        data: query
    })
}

//批量申请证书证章获取数据
export function GetBulkApplyCertificatePerson(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetBulkApplyCertificatePerson',
        method: 'post',
        data: query
    })
}

//批量申请证书证章提交数据
export function CreatePaperCertificate(query) {
    return request({
        url: '/api/services/app/TestOrg/CreatePaperCertificate',
        method: 'post',
        data: query
    })
}

// 申诉记录
export function getAthleteData(query) {
    return request({
        url: '/api/services/app/TestOrg/getAthleteData',
        method: 'post',
        data: query
    })
}

// 申诉记录查询成绩
export function getAthleteDetails(query) {
    return request({
        url: '/api/services/app/TestOrg/getAthleteDetails',
        method: 'post',
        data: query
    })
}

// 修改成绩申诉
export function UpdateAthleteSSAppeal(query) {
    return request({
        url: '/api/services/app/TestOrg/UpdateAthleteSSAppeal',
        method: 'post',
        data: query
    })
}

// 修改成绩申诉
export function UpdateAthleteAppeal(query) {
    return request({
        url: '/api/services/app/TestOrg/UpdateAthleteAppeal',
        method: 'post',
        data: query
    })
}

// 申诉驳回
export function UpdateAthleteBHsAppeal(query) {
    return request({
        url: '/api/services/app/TestOrg/UpdateAthleteBHsAppeal',
        method: 'post',
        data: query
    })
}

// 测试机构详情页
export function getTestMechanismData(query) {
    return request({
        url: '/api/services/app/TestOrg/getTestMechanismData',
        method: 'post',
        data: query
    })
}

export function getTestMechanismData2(query) {
    return request({
        url: '/api/services/app/TestOrg/getTestMechanismData2',
        method: 'post',
        data: query
    })
}

//企业实名认证   XXL   2020年11月9日 11:37:37
export function GetCompanyVerifyUrl(query) {
    return request({
        url: '/api/services/app/Contract/GetCompanyVerifyUrl',
        method: 'post',
        data: query
    })
}

//GetApplycert     /api/services/app/Contract/Applycert
//   企业申请证书    XXL   2020年11月13日 10:34:03
export function GetApplycert(query) {
    return request({
        url: '/api/services/app/Contract/Applycert',
        method: 'post',
        data: query
    })
}

//UserTestMechanismDetail
//查询测试机构是否认证   2020年11月13日 11:36:09    XXL
export function GetUserTestMechanismDetail(query) {
    return request({
        url: '/api/services/app/Contract/UserTestMechanismDetail',
        method: 'post',
        data: query
    })
}

// 上传印章  2020年11月13日 15:29:07  XXL
export function GetAddsignature(query) {
    return request({
        url: '/api/services/app/Contract/Addsignature',
        method: 'post',
        data: query
    })
}

// 获取合同列表  2020年11月13日 15:29:07  XXL
export function GetContractList(query) {
    return request({
        url: '/api/services/app/Contract/GetContractList',
        method: 'post',
        data: query
    })
}

//
export function GetExtsign(query) {
    return request({
        url: '/api/services/app/Contract/Extsign',
        method: 'post',
        data: query
    })
}

// 退费
export function saveRefund(data) {
    return request({
        url: '/api/services/app/TestOrg/SaveRefund',
        method: 'post',
        data: data
    })
}

// 补考报名信息列表
export function GetRetakeApplicationList(query) {
    return request({
        url: '/api/services/app/TestOrg/GetRetakeApplicationList',
        method: 'post',
        data: query
    })
}
